import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Client1 from '../Images/1.png'
import Client2 from '../Images/2.png'
import Client3 from '../Images/3.png'

function ProductTestimonials() {

    const testimonials = [
        {
            name: "Madeniko Mojika",
            designation: "Branding Identity",
            content: "Our support team will get assistance from AI-powered suggestions, making it quicker than ever to handle support requests.",
            image: Client1
        },
        {
            name: "John Doe",
            designation: "Web Developer",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            image: Client2
        },
        {
            name: "Jane Smith",
            designation: "Graphic Designer",
            content: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
            image: Client3
        },
    ];


    const options = {
        loop: true,
        margin: 10,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 1,
            },
        },
        smartSpeed: 1500,
    };

    return (
        <div className="sbst-testimonial-area mg-top-80">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-9">
                        <div className="section-title style-two text-center">
                            <h2 className="title">What Our <span>Client Say?</span></h2>
                            <p>Our support team will get assistance from AI-powered suggestions, making it quicker than ever to support requests. Our support team will get from AI-powered suggestions.</p>
                        </div>
                    </div>
                </div>
                <div className="testimonial-slider2-bg">
                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            <OwlCarousel className="owl-theme testimonial-slider-2" {...options}>
                                {testimonials.map((testimonial, index) => (
                                    <div className="item" key={index}>
                                        <div className="media text-center">
                                            <div className="media-left">
                                                <img src={testimonial.image} alt="client" />
                                            </div>
                                            <div className="media-body">
                                                <p>{testimonial.content}</p>
                                                <h6>{testimonial.name}</h6>
                                                <span>{testimonial.designation}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductTestimonials;
